import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Select from 'react-select';
import { CModal, CModalHeader, CAccordion, CAccordionItem, CModalBody, CAccordionBody, CAccordionHeader, CModalTitle, CButton } from '@coreui/react';
import { BsArrowRight, BsArrowBarDown } from 'react-icons/bs';
import axios from 'axios';
import '../../../assets/css/mainstyle.css';
import api from '../../../service/caller';
import choco from '../../../assets/images/choco.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getUserIdFromToken } from '../../../utils/authUtils';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';


const AddAppointmentModal = ({ visible, onClose, onAppointmentAdded, patientId, patientlastName, patientfirstName }) => {
    const navigate = useNavigate();
    const [UserData, setUserData] = useState([]);
    const [userRole, setUserRole] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [hospitalId, setHospitalId] = useState(null);
    const [message, setMessage] = useState('');
    const [appointmentInfo, setAppointmentInfo] = useState(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [specificDoctor, setSpecificDoctor] = useState(false);
    const [doctors, setDoctors] = useState([]);
    const [patients, setPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState(patientId || '');
    const [patientIdinf, setpatientIdinf] = useState(null);
    const [doctorMessage, setDoctorMessage] = useState('');
    const [assignedDoctorMessage, setAssignedDoctorMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
    const [isLoadingTimeSlots, setIsLoadingTimeSlots] = useState(false);
    const [showTimeSlots, setShowTimeSlots] = useState(false);
    const [appointmentData, setAppointmentData] = useState({
        patient_Name: `${patientfirstName || ''} ${patientlastName || ''}`.trim(),
        hospitalId: '',
        motif: 'Consultation',
        type_consultation: '',
        department: '',
        price: '',
        notes: '',
        appointmentTime: '',
        appointmentDate: '',
        patientId: patientId,
        doctorId: '',
        appointmentEndTime: '',
    });

    const departmentId = appointmentData?.department;

    // les information de l'utilisateur
    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }

                const response = await api.get('api/usersprofile');
                setUserData(response.data);
                const hospitalIds = response.data.hospital_id;

                if (hospitalIds && hospitalIds.length === 1) {
                    // Si un seul hôpital est présent, on le met dans l'état `hospitalId`
                    setHospitalId(hospitalIds[0]);
                } else {
                    // Si plusieurs hôpitaux sont présents, on laisse le champ sélectionnable
                    setHospitalId(null); // Laissez vide pour permettre à l'utilisateur de sélectionner
                }
                setUserRole(response.data.role.name);
                if (response.data.role.name == "medtinz_client_patient") {
                    const patientResponse = await api.get('/clinic/getPatientByUserId', {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    setpatientIdinf(patientResponse.data);
                }
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    // recuperer les docteur pour un departement 
    const fetchDoctors = async () => {
        try {
            const response = await api.get(`/api/getDoctorsByDepartment/${departmentId}`);
            if (response.data && response.data.data) {
                setDoctors(response.data.data);
            } else {
                setDoctorMessage("Aucun médecin trouvé pour ce département.");
            }
        } catch (err) {
            console.error('Erreur détaillée:', err);
            setDoctorMessage(`Erreur lors du chargement des docteurs: ${err.message}`);
        }
    };

    // listes des departments
    useEffect(() => {
        // if (UserData?.hospital_id && !departments.length) {
            fetchDepartments(appointmentData.hospitalId);
        // }
    }, [appointmentData.hospitalId]);

    // Utiliser useEffect pour appeler fetchDoctors dès que le département change
    useEffect(() => {
        if (appointmentData.department) {
            fetchDoctors(appointmentData.department);  // Appelle la fonction pour récupérer les médecins
        }
    }, [appointmentData.department]); // L'appel sera effectué lorsque le département change

    const fetchDepartments = async (hospitalIds) => {
        if (!hospitalIds || hospitalIds.length === 0) {
            console.error("Erreur: hospitalIds est vide ou non disponible");
            return;
        }

        try {
            // Faire l'appel API avec un tableau de hospitalIds
            const response = await api.get(`/api/departments/hospital/${appointmentData.hospitalId}`);

            console.log("Nombre de départements reçus:", response.data.data.length);
            setDepartments(response.data.data);

        } catch (error) {
            console.error('Erreur lors de la récupération des départements:', error);
            if (error.response) {
                // La requête a été faite et le serveur a répondu avec un code d'état
                console.error('Données de réponse:', error.response.data);
                console.error('Statut:', error.response.status);
            } else if (error.request) {
                // La requête a été faite mais aucune réponse n'a été reçue
                console.error('Requête sans réponse:', error.request);
            } else {
                // Une erreur s'est produite lors de la configuration de la requête
                console.error('Erreur de configuration:', error.message);
            }
        }
    };

    const fetchAvailableTimeSlots = async (date) => {
        if (!date || !appointmentData.department) {
            return;
        }

        setIsLoadingTimeSlots(true);
        try {
            const allAvailableSlots = [];

            // Pour chaque médecin, récupérer ses disponibilités
            for (const doctor of doctors) {
                try {
                    const response = await api.get('/clinic/doctorAvailability', {
                        params: {
                            doctorId: doctor._id,
                            appointmentDate: date,
                        }
                    });
                    console.log("doctor", doctor)

                    if (response.data && response.data.availableSlots && response.data.availableSlots.length > 0) {
                        // Ajouter les informations du médecin à chaque créneau disponible
                        const doctorSlots = response.data.availableSlots.map(slot => ({
                            ...slot,
                            doctorId: doctor._id,
                            doctorName: `Dr. ${doctor.firstname} ${doctor.lastname}`,
                            speciality: doctor.speciality || doctor.department?.name
                        }));

                        allAvailableSlots.push(...doctorSlots);
                    }
                } catch (error) {
                    console.error(`Erreur pour le médecin ${doctor._id}:`, error);
                    // Continuer avec les autres médecins malgré l'erreur
                }
            }

            // Trier les créneaux par heure de début
            allAvailableSlots.sort((a, b) => {
                if (a.start < b.start) return -1;
                if (a.start > b.start) return 1;
                return 0;
            });

            setAvailableTimeSlots(allAvailableSlots);

            if (allAvailableSlots.length === 0) {
                toast.info("Aucun créneau disponible pour cette date");
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des créneaux horaires:', error);
            toast.error("Impossible de récupérer les créneaux horaires disponibles");
            setAvailableTimeSlots([]);
        } finally {
            setIsLoadingTimeSlots(false);
        }
    };

    const selectTimeSlot = (slot) => {
        setAppointmentData(prev => ({
            ...prev,
            appointmentTime: slot.start,
            appointmentEndTime: slot.end,
            doctorId: slot.doctorId
        }));

        // Afficher les informations du médecin assigné
        setAssignedDoctorMessage(`Le rendez-vous sera assigné au médecin ${slot.doctorName}.`);
        setMessageType('success');
    };

    // gestion du formulaire
    const handleChange = (selectedOption, actionMeta) => {
        const { name } = actionMeta;
        const value = selectedOption ? selectedOption.value : '';

        if (name === 'department') {
            // Trouver le département correspondant dans la liste des départements
            const selectedDepartment = departments.find(department => department._id === value);
            setAppointmentData({
                ...appointmentData,
                department: value,
                price: selectedDepartment ? selectedDepartment.price_consult : '',
            });
        } else {
            setAppointmentData({
                ...appointmentData,
                [name]: value
            });
        }
    };

    // Pour gérer les inputs standards (non-Select)
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAppointmentData({
            ...appointmentData,
            [name]: value
        });
    };

    // Gérer le changement de date pour suggérer des horaires
    const handleDateChange = (e) => {
        const selectedDate = e.target.value;
        handleInputChange(e);

        // Reset appointment time when date changes
        setAppointmentData(prev => ({
            ...prev,
            appointmentDate: selectedDate,
            appointmentTime: ''
        }));

        // Fetch available time slots for the selected date
        if (selectedDate && appointmentData.department) {
            fetchAvailableTimeSlots(selectedDate);
        }
    };

    // Fonction pour calculer l'heure de fin d'un rdv
    const calculateEndTime = (startTime, durationInMinutes) => {
        const start = new Date(`1970-01-01T${startTime}:00Z`);  // On crée une date à partir de l'heure de début
        const end = new Date(start.getTime() + durationInMinutes * 60000);  // Ajoute la durée en minutes
        const endTime = end.toISOString().substr(11, 5);  // Extrait uniquement l'heure et les minutes
        return endTime;
    };

    // Fonction réutilisable pour vérifier la disponibilité des médecins
    const checkDoctorAvailability = async () => {
        // Vérifie que la date et l'heure sont sélectionnées avant de procéder
        if (!appointmentData.appointmentDate || !appointmentData.appointmentTime) {
            setAssignedDoctorMessage('Veuillez sélectionner une date et une heure.');
            setMessageType('danger');
            return false;  // Si la date ou l'heure est manquante, retourne false
        }

        // Si la date et l'heure sont sélectionnées, procéder à la vérification de la disponibilité
        let availableDoctors = [];

        try {
            // Calculer l'heure de fin du rendez-vous (par exemple, durée de 30 minutes)
            const appointmentDuration = 30;  // valeur dynamique
            appointmentData.appointmentEndTime = calculateEndTime(appointmentData.appointmentTime, appointmentDuration);

            // Vérification de la disponibilité de chaque médecin
            availableDoctors = await Promise.all(doctors.map(async (doctor) => {
                const response = await api.get('/clinic/checkDoctorAvailability', {
                    params: {
                        doctorId: doctor._id,
                        appointmentDate: appointmentData.appointmentDate,
                        appointmentTime: appointmentData.appointmentTime,
                        appointmentEndTime: appointmentData.appointmentEndTime,
                    },
                });

                if (response.data.isAvailable) {
                    return doctor;
                } else {
                    return null;
                }
            }));

            availableDoctors = availableDoctors.filter(doctor => doctor !== null);

            if (availableDoctors.length > 0) {
                setAssignedDoctorMessage(`Le rendez-vous sera assigné au médecin ${availableDoctors[0].lastname} ${availableDoctors[0].firstname}.`);
                setMessageType('success');  // Afficher un message de succès
                return availableDoctors[0];  // Retourner le premier médecin disponible
            } else {
                setAssignedDoctorMessage('Aucun médecin disponible pour ce créneau.');
                setMessageType('danger');  // Afficher un message d'erreur
                return null;
            }
        } catch (error) {
            console.error('Erreur lors de la vérification des médecins:', error);
            setAssignedDoctorMessage('Erreur lors de la vérification des disponibilités.');
            setMessageType('danger');
            return null;
        }
    };

    // Gérer les changements de date ou d'heure
    const handleDateOrTimeChange = async () => {
        const assignedDoctor = await checkDoctorAvailability();
    };

    // Fonction pour formatter l'heure pour affichage
    const formatTimeForDisplay = (time) => {
        if (!time) return "";

        // Convert 24h format to AM/PM format
        const [hours, minutes] = time.split(':');
        const hr = parseInt(hours, 10);
        const ampm = hr >= 12 ? 'PM' : 'AM';
        const hr12 = hr % 12 || 12;

        return `${hr12}:${minutes} ${ampm}`;
    };

    useEffect(() => {
        if (hospitalId) {
            setAppointmentData((prevState) => ({
                ...prevState,
                hospitalId: hospitalId._id,
            }));
        }
    }, [hospitalId]);

    // metre a jour patient id 
    useEffect(() => {
        if (patientIdinf) {
            setAppointmentData((prevState) => ({
                ...prevState,
                patientId: patientIdinf._id,
            }));
        }
    }, [patientIdinf]);

    // Préparer les options pour les Select
    const patientOptions = patients.map(patient => ({
        value: patient._id,
        label: `${patient.firstname} ${patient.lastname}`
    }));

    const hospitalOptions = UserData?.hospital_id?.map(hospital => ({
        value: hospital._id,
        label: hospital.hospital_name
    })) || [];

    const departmentOptions = departments.map(department => ({
        value: department._id,
        label: department.name
    }));

    const motifOptions = [
        { value: 'Consultation', label: 'Consultation' },
        { value: 'Control', label: 'Control' }
    ];

    const typeConsultationOptions = [
        { value: 'inperson', label: 'In Person' },
        { value: 'online', label: 'Telemedicine' }
    ];

    // Gérer la soumission du formulaire
    // Gérer la soumission du formulaire
const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    const requiredFields = {
        patientId: "Patient",
        hospitalId: "Hospital",
        department: "Department",
        motif: "Motif",
        price: "Price"
    };
    
    // Check if any required field is empty
    const missingFields = [];
    for (const [field, label] of Object.entries(requiredFields)) {
        if (!appointmentData[field]) {
            missingFields.push(label);
        }
    }
    
    // If there are missing fields, show error message and don't proceed
    if (missingFields.length > 0) {
        toast.error(`Please fill in the following fields: ${missingFields.join(', ')}`);
        return;
    }
    
    // All validations passed, proceed with the form submission
    const hospitalIdToSend = appointmentData.hospitalId;
    
    // Now navigate to the next page
    navigate('/hospitaladmin/schedulerdv', {
        state: {
            appointmentData,
            hospitalId: hospitalIdToSend,
        }
    });
};

    // fermer le modal de succes
    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        onClose();
        navigate('/hospitaladmin/Appointmentlist');
    };

    // Fonction pour obtenir la date actuelle sous format YYYY-MM-DD
    const getTodayDate = () => {
        const today = new Date();
        const day = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        return `${year}-${month}-${day}`;
    };

    // patients
    const fetchPatients = async (hospitalIds) => {
        if (!hospitalIds || hospitalIds.length === 0) {
            console.error("Erreur: hospitalIds est vide ou non disponible");
            return;
        }
        try {
            // Faire l'appel API avec un tableau de hospitalIds
            const response = await api.get(`/clinic/patients`, {
                params: { hospitalIds } // Envoi d'un tableau d'IDs de hospital
            });

            console.log("Nombre de patients reçus:", response.data.patients.length);
            setPatients(response.data.patients);

        } catch (error) {
            console.error('Erreur lors de la récupération des patients:');
            if (error.response) {
                console.error('Données de réponse:', error.response.data);
                console.error('Statut:', error.response.status);
            } else if (error.request) {
                console.error('Requête sans réponse:', error.request);
            } else {
                console.error('Erreur de configuration:', error.message);
            }
        }
    };

    // Utilisation de useEffect pour charger les données
    useEffect(() => {
        if (UserData && UserData.hospital_id && Array.isArray(UserData.hospital_id) && UserData.hospital_id.length > 0) {
            // Vérifiez si hospital_id est un tableau et le passez à fetchPatients
            const hospitalIds = UserData.hospital_id;
            fetchPatients(hospitalIds);
        } else {
            console.error("UserData ou hospital_id non disponible pour fetchPatients");
        }
    }, [UserData]);
    

    // Mettre à jour appointmentData avec les informations du patient sélectionné
    useEffect(() => {
        if (selectedPatient) {
            const selectedPatientData = patients.find(patient => patient._id === selectedPatient);
            if (selectedPatientData) {
                setAppointmentData({
                    ...appointmentData,
                    patient_Name: `${selectedPatientData.firstname} ${selectedPatientData.lastname}`,
                    patientId: selectedPatientData._id,
                });
            }
        }
    }, [selectedPatient, patients]);

    const handlePrint = async () => {
        const element = document.querySelector('.ticketpayment');
        if (!element) return;

        try {
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                backgroundColor: '#ffffff'
            });

            const imgData = canvas.toDataURL('image/jpeg', 1.0);
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const imgWidth = 210; // A4 width
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
            pdf.save(`${appointmentInfo._id}_Apt.pdf`);
        } catch (error) {
            console.error('Erreur de génération PDF:', error);
        }
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: '38px',
            borderRadius: '4px',
            borderColor: '#ced4da',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#80bdff'
            }
        }),
        placeholder: (base) => ({
            ...base,
            color: '#6c757d'
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#f8f9fa' : 'white',
            color: '#495057',
            '&:active': {
                backgroundColor: '#e9ecef'
            }
        })
    };

    return (
        <CModal className='newregistermodal'
            alignment="center"
            scrollable
            size='lg'
            visible={visible}
            onClose={onClose}
            aria-labelledby="VerticallyCenteredScrollableExample2"
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredScrollableExample2" className='Titleformsmodal'>Register New Appointment</CModalTitle>
            </CModalHeader>
            <CModalBody className="p-5">
                <form onSubmit={handleSubmit}>
                    {/* Sélecteur de patient */}
                    <div className="form-group">
                        <label htmlFor="patient_Name">Patient Name</label>
                        {patientIdinf ? (
                            <>
                                <input
                                    type="text"
                                    value={`${patientIdinf.lastname} ${patientIdinf.firstname}`}
                                    disabled
                                />
                                <input
                                    type="hidden"
                                    name="patientId"
                                    value={patientIdinf._id || ''}
                                />
                            </>
                        ) : (
                            <Select
                                options={patientOptions}
                                value={patientOptions.find(option => option.value === selectedPatient)}
                                onChange={(option) => setSelectedPatient(option ? option.value : '')}
                                placeholder="Select a patient"
                                styles={customStyles}
                                isClearable
                                isSearchable
                            />
                        )}
                    </div>

                    <div className="form-group">
                        <label htmlFor="hospitalId">Hospital</label>
                        {hospitalId ? (
                            <>
                                <input
                                    type="text"
                                    name="hospitalname"
                                    value={hospitalId.hospital_name || ''}
                                    disabled
                                />
                                <input
                                    type="hidden"
                                    name="hospitalId"
                                    value={hospitalId._id || ''}
                                />
                            </>
                        ) : (
                            <Select
                                options={hospitalOptions}
                                value={hospitalOptions.find(option => option.value === appointmentData.hospitalId)}
                                onChange={(option) => setAppointmentData({ ...appointmentData, hospitalId: option ? option.value : '' })}
                                placeholder="Select Hospital"
                                styles={customStyles}
                                isClearable
                                isSearchable
                            />
                        )}
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="motif">Motif</label>
                        <Select
                            options={motifOptions}
                            value={motifOptions.find(option => option.value === appointmentData.motif)}
                            onChange={(selectedOption) => handleChange(selectedOption, { name: 'motif' })}
                            placeholder="Select Motif"
                            styles={customStyles}
                            defaultValue={motifOptions[0]}
                        />
                    </div>
                    
                    <div className="form-group">
                        {message && <p>{message}</p>}
                        <label htmlFor="department">Department</label>
                        <Select
                            options={departmentOptions}
                            value={departmentOptions.find(option => option.value === appointmentData.department)}
                            onChange={(selectedOption) => handleChange(selectedOption, { name: 'department' })}
                            placeholder="Selectionner le departement"
                            styles={customStyles}
                            isClearable
                            isSearchable
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="price">Prix</label>
                        <input
                            type="number"
                            name="price"
                            value={appointmentData.price}
                            onChange={handleInputChange}
                            disabled required
                        />
                    </div>

                    <div className="form-group">
                        <textarea
                            name="notes"
                            value={appointmentData.notes}
                            onChange={handleInputChange}
                            placeholder='Raison de la consultation'
                        ></textarea>
                    </div>

                    <div className="savenewuser form-group d-flex justify-content-center">
                        <CButton type="submit">
                            Schedule Appointment &nbsp; <BsArrowRight />
                        </CButton>
                    </div>
                </form>
            </CModalBody>

            <div className='timetablelast'>
                {/* Deuxième Modal */}
                {showSuccessModal && (
                    <div className="modal-overlay">
                        <div className="modal-content2">
                            <div className='ticketpayment p-3'>
                                <div className="text-center vie mb-4 mt-3">
                                    <h2 className="text-lg semibold mb-4">SUCCESS</h2>
                                </div>

                                <div className="immole">
                                    <div className="text-start">
                                        <p><strong>Rdv Enregistre avec success</strong> </p>
                                        <p>Veuillez passer a la caisse avec ce numero<strong style={{ color: 'green' }}> {appointmentInfo?.paymentuniqueId}</strong> pour effectuer votre payement</p>
                                        <p><strong>Appointment Code:</strong> {appointmentInfo?.AppointmentCode}</p>
                                        <p><strong>Patient :</strong> {appointmentData.patient_Name}</p>
                                        <p><strong>Motif:</strong> {appointmentInfo?.motif}</p>
                                        <p><strong>Type Consultation:</strong> {appointmentInfo?.type_consultation}</p>
                                        <p><strong>Department:</strong> {
                                            // Find the department name based on the department ID
                                            departments.find(department => department._id === appointmentInfo.department)?.name || 'N/A'
                                        }</p>
                                        <p><strong>Price:</strong> {appointmentInfo?.price} FCFA</p>
                                        <p><strong>Notes:</strong> {appointmentInfo?.notes}</p>
                                    </div>
                                    <div>
                                        <img src={choco} alt="choco" className="choco" />
                                    </div>
                                </div>
                            </div>

                            <div className='mt-4 btnactionpatientcard' >
                                <CButton className="w-100" style={{ backgroundColor: '#FF9800' }} onClick={handlePrint}>
                                    Telecharger<BsArrowBarDown className='ms-2' />
                                </CButton>
                                <CButton className="w-100" style={{ backgroundColor: '#28A745' }} onClick={handleCloseSuccessModal} >
                                    close <BsArrowRight className='ms-2' />
                                </CButton>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </CModal>
    );
};

export default AddAppointmentModal;